import { createContext, Dispatch, SetStateAction } from 'react';

export interface CalendarContextType {
  selectedCalendarArtists: string[];
  setSelectedCalendarArtists: Dispatch<SetStateAction<string[]>>;
}

const defaultContextValue: CalendarContextType = {
  selectedCalendarArtists: [],
  setSelectedCalendarArtists: () => {},
};

export const CalendarContext =
  createContext<CalendarContextType>(defaultContextValue);
